import { combineReducers } from 'redux';
import pricePoints from './dictionaries/price-point-dictionary';
import packStatuses from './dictionaries/pack-statuses-dictionary';
import orderStatuses from './dictionaries/order-statuses-dictionary';
import userClass from './dictionaries/user-class-dictionary';
import reportCategories from './dictionaries/report-categories-dictionary';
import tiers from './dictionaries/tiers-dictionary';
import terms from './dictionaries/lottery-terms-dictionary';
import privilegeDisplayTypes from './dictionaries/privilege-display-types-dictionary';
import inquiryReasons from './dictionaries/inquiry-reasons-dictionary';

import invoiceDates from './dictionaries/invoice-dates-dictionary';
import userTemplates from './dictionaries/user-templates-dictionary';
import outletTypes from './dictionaries/outlet-types-dictionary';
import sftpAuthenticationTypes from './dictionaries/sftp-authentication-types';
import activityEvents from './dictionaries/activity-events-dictionary';

const dictionary = combineReducers({
  pricePoints,
  packStatuses,
  orderStatuses,
  userClass,
  reportCategories,
  tiers,
  invoiceDates,
  userTemplates,
  outletTypes,
  sftpAuthenticationTypes,
  activityEvents,
  terms,
  privilegeDisplayTypes,
  inquiryReasons,
});

export default dictionary;



// WEBPACK FOOTER //
// ./src/modules/app/reducers/dictionary.reducer.js